
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'prueba',
	'visualizationSlideoutTitle': 'Visualizaciones',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Especifique un número',
	'maxValuePlaceholder': 'Especifique un número',
	'customRangeErrorMessage': 'El valor debe ser un número',
	'propFillColor': 'Color de relleno',
	'propBorderColor': 'Color del borde',
	'propColorPalette': 'Paleta de colores actual',
	'propColorPaletteChangeLabel': 'Cambiar paleta de colores',
	'propNewColorPaletteLabel': 'Crear una paleta de colores personalizada',
	'propNewHeatPaletteLabel': 'Crear una paleta de uso crítico personalizada',
	'propDonutRadius': 'Radio de anillo',
	'showTitleLabel': 'Mostrar título',
	'titleTypeLabel': 'Tipo de título',
	'smartTitleLabel': 'Título inteligente',
	'customTitleLabel': 'Título personalizado',
	'noTitleLabel': 'Sin título ',
	'propHeatScalePalette': 'Paleta de uso crítico actual',
	'propHeatPaletteChangeLabel': 'Cambiar paleta de uso crítico',
	'propMaintainAxisScales': 'Mantener escala de eje',
	'propLineAndSymbolColor': 'Color de línea y símbolo',
	'propLineAndSymbolPalette': 'Paleta de colores de línea y símbolo',
	'propElementColor': 'Color de elementos',
	'propColumnColor': 'Color de columnas',
	'propColumnPalette': 'Paleta de colores de columna',
	'propColumnHeatPalette': 'Paleta de uso crítico de columna',
	'propBarColor': 'Color de barra',
	'propGoalColor': 'Color de destino',
	'propToColor': 'A color',
	'propFromColor': 'De color',
	'propNumberValidationErrorMessageId': 'Escriba un número',
	'fontSizeAuto': 'Automático',
	'propAutoBinCount': 'Número de grupos',
	'propAutoBinToggle': 'Agrupación automática',
	'tabName_general': 'General',
	'tabName_visDetails': 'Detalles',
	'tabName_animation': 'Animación',
	'tabName_mediaDetails': 'Detalles del soporte multimedia',
	'tabName_webDetails': 'Detalles de la página web',
	'tabName_imageDetails': 'Detalles de la imagen',
	'tabName_visualization': 'Visualización',
	'tabName_text': 'Texto',
	'sectionName_colorsAndThemes': 'Color y temas',
	'sectionName_appearance': 'Aspecto',
	'sectionName_general': 'General',
	'sectionName_colorPalette': 'Color',
	'sectionName_axis': 'Eje',
	'sectionName_axis_label': 'Eje',
	'sectionName_legend': 'Leyenda',
	'sectionName_chart': 'Gráfico',
	'sectionName_regionLayer': 'Capa de regiones',
	'sectionName_pointLayer': 'Capa de puntos',
	'sectionName_latLongLayer': 'Capa de latitud/longitud',
	'sectionName_pathLayer': 'Capa de vía de acceso',
	'propTransparencyDescription': 'Hacer que el objeto sea más o menos transparente. Especifique un valor entre 0 y 100',
	'smart_annotation_unauthorized': 'Anotaciones: acceso no autorizado',
	'smart_annotation_method': 'Anotaciones: método no permitido',
	'smart_annotation_media': 'Anotaciones: tipo de soporte no permitido',
	'smart_annotation_input': 'Anotaciones: entrada no válida',
	'smart_annotation_internal': 'Anotaciones: error interno del sistema',
	'smart_annotation_generic_error': 'Anotaciones: error de servicio',
	'smart_annotation_dialog_title': 'Conocimientos',
	'smart_errors': 'Errores de anotación:',
	'smart_warnings': 'Avisos de anotación:',
	'smart_annotation_insight_icon_title': 'Conocimientos',
	'smart_annotations_toggle_on': 'Activar conocimientos',
	'smart_annotations_toggle_off': 'Desactivar conocimientos',
	'smart_annotation_insight_unavailable': 'Los conocimientos no están disponibles actualmente',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Los conocimientos no están disponibles cuando se aplica el filtro de % superior o inferior',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Las predicciones no están disponibles cuando se aplica el filtro de % superior o inferior',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Los conocimientos no están disponibles cuando se aplica el filtro de porcentaje superior o inferior y hay más de una columna en el campo',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Las predicciones no están disponibles cuando se aplica el filtro de porcentaje superior o inferior y hay más de una columna en el campo',
	'forecast_title': 'Predicción',
	'forecast_toggle_on': 'Conmutar activar predicción',
	'forecast_toggle_off': 'Conmutar desactivar predicción',
	'statDetailsPerspectiveTitle': 'Análisis',
	'emptyStatDetailsPanel': 'No hay ningún análisis adicional disponible para la visualización actual.',
	'predict_errors': 'Errores de análisis',
	'predict_warnings': 'Avisos de análisis',
	'fpd_invalid_data_source': 'Este origen de datos no tiene asociado un módulo Smarts',
	'fpd_network_issue': 'Se ha producido un problema al realizar un análisis en este origen de datos',
	'fpd_data_source_category': 'Falta un módulo Smarts',
	'fpd_response_errors': 'Errores de controladores recomendados',
	'fpd_response_warnings': 'Avisos de controladores recomendados',
	'catalyst_service_bad_request': 'Solicitud incorrecta',
	'catalyst_service_unkown_Id': 'Se ha encontrado una ID de solicitud desconocida',
	'catalyst_service_internal_server_error': 'Error interno del servidor',
	'catalyst_service_generic_error': 'Error de servicio Catalyst',
	'catalyst_service_error': 'Este servicio no está disponible actualmente.',
	'propLegendPosition': 'Posición de la leyenda',
	'propLeft': 'Izquierda',
	'propRight': 'Derecha',
	'propTop': 'Arriba',
	'propBottom': 'Abajo',
	'propNone': 'Ninguno',
	'propLegendDisplay': 'Visualizar leyenda',
	'targetThicknessPlaceHolder': '%{min} a %{max}',
	'targetThicknessErrorMsg': 'Escriba un número entero entre %{min} y %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Controladores (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'seleccionado)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Restablecer los valores predeterminados',
	'possibelKeyDriver_AddNewDrivers': 'Añadir más controladores',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Buscar para añadir más controladores',
	'possibleKeyDrivers_MaxPossibleReached': 'Deseleccione algunos controladores para añadir o seleccionar otros',
	'possibleKeyDrivers_Recommended': 'Recomendado',
	'visRecommendedTypes': 'Tipos de visualización recomendados',
	'visRecommender_smartsfailure': 'las recomendaciones de visualización no están disponibles actualmente',
	'visMore': 'Más...',
	'visMoreTooltip': 'Más visualizaciones',
	'visOtherTypes': 'Otros tipos de visualización',
	'visChange': 'Cambiar visualización',
	'automaticTypeCaption': 'Automático',
	'propVisType': 'Tipos de visualización',
	'dlg_loading': 'Cargando...',
	'snippetListChartCaption': 'Lista de fragmentos',
	'convoClusterChartCaption': 'Clúster de conversación',
	'areaChartCaption': 'Área',
	'barChartCaption': 'Barras',
	'columnChartCaption': 'Columna',
	'stackedbarChartCaption': 'Barras apiladas',
	'stackedcolumnChartCaption': 'Columnas apiladas',
	'bubbleChartCaption': 'Burbuja',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Análisis de controlador',
	'scatterChartCaption': 'Dispersión',
	'lineChartCaption': 'Línea',
	'pointChartCaption': 'Puntos',
	'heatChartCaption': 'Mapa de uso crítico',
	'bulletChartCaption': 'Viñeta',
	'waterfallChartCaption': 'Cascada',
	'pieChartCaption': 'Circular',
	'mapChartCaption': 'Mapa',
	'radialBarChartCaption': 'Radial',
	'compositeChartCaption': 'Línea y columna',
	'wordCloudChartCaption': 'Nube de palabras',
	'networkChartCaption': 'Red',
	'relationshipNetworkChartCaption': 'Red de relaciones',
	'treemapChartCaption': 'Mapa de árbol',
	'packedBubbleChartCaption': 'Burbuja empaquetada',
	'hierarcicalPackedBubbleChartCaption': 'Burbuja de jerarquía',
	'spiralChartCaption': 'Espiral',
	'decisionTreeChartCaption': 'Árbol de decisiones',
	'legacyMapChartCaption': 'Mapa heredado',
	'sunburstChartCaption': 'Sunburst',
	'visUsageComparison': 'Comparación',
	'visUsageRelationships': 'Relaciones',
	'visUsageTrend': 'Tendencia',
	'visUsagePartsToWhole': 'Componentes del conjunto',
	'visUsageGeospatial': 'Geoespacial',
	'visUsageAdvanced': 'Análisis avanzado',
	'visUsageTablesAndSummary': 'Tablas y resumen',
	'visUsageSocialInsights': 'Social insights',
	'visUsageOther': 'Otros',
	'autoBinActionText': 'Agrupar automáticamente',
	'filterAutobinActionText': 'Filtrar cubetas',
	'memberCalculationActionText': 'Cálculo de miembros',
	'toolbarActionCalculation': 'Cálculo',
	'toolbarActionEditCalculation': 'Editar cálculo',
	'topBottomRankLabel': 'Rango (%{label})',
	'toolbarDeleteFilterActionText': 'Eliminar filtro',
	'toolbarActionTopKeyDrivers': 'Mostrar controladores',
	'toolbarActionCustomGroup': 'Grupo personalizado',
	'canNotCreateCustomGroup': 'No se puede crear este grupo personalizado.',
	'aria_label_datatable': 'Tabla de datos',
	'summaryCaption': 'Resumen',
	'MeasuresCaption': 'Medidas',
	'MeasuresGroupCaption': 'Grupo de medidas (%{count})',
	'ValuesCaption': 'Valores',
	'turnInsightsOn': 'Activar conocimientos',
	'turnInsightsOff': 'Desactivar conocimientos',
	'decisionRules': 'Reglas',
	'decisionTree': 'Diagrama de árbol',
	'decisionSunburst': 'Árbol Sunburst',
	'switchToDecisionRules': 'Cambiar a las reglas de decisión',
	'switchToDecisionTree': 'Cambiar al árbol de decisión',
	'data_group_less_then': 'menor que %{rangeTo}',
	'data_group_to': 'De %{rangeFrom} a < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} y superiores',
	'nullValueContent': '(ningún valor)',
	'sum': 'Suma',
	'count': 'Recuento',
	'countdistinct': 'Recuento Distinct',
	'avg': 'Promedio',
	'min': 'Mínimo',
	'max': 'Máximo',
	'automatic': 'Personalizada',
	'variance': 'Varianza',
	'stddev': 'Desviación estándar',
	'median': 'Mediana',
	'calculated': 'Calculado',
	'none': 'Ninguno',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'unSupportedPromptType': 'El escenario de solicitud no está soportado actualmente.',
	'preAggregateLabel': 'Aplicar valores de solicitud del origen de datos',
	'postAggregateLabel': 'Aplicar valores de solicitud en el informe',
	'preAggregateText': 'El rango utiliza los valores del origen de datos, no los valores mostrados en el panel de control.',
	'defaultAggregation_count': 'Recuento',
	'defaultAggregation_countdistinct': 'Recuento Distinct',
	'defaultAggregation_max': 'Máximo',
	'defaultAggregation_min': 'Mínimo',
	'defaultAggregation_avg': 'Promedio',
	'defaultAggregation_sum': 'Suma',
	'defaultAggregation_auto': 'Automático (%{aggregationType})',
	'keydriver_average': 'Promedio global',
	'keydriver_up_down': 'Los grupos resaltados con promedios altos o bajos tienen más impacto en el destino. Los grupos con promedios más altos o bajos de lo habitual tienen el impacto más fuerte.',
	'keydriver_different': 'Los grupos resaltados tienen distribuciones que difieren de forma destacada de la distribución global. Estos grupos tienen más impacto en el destino.',
	'topOperator': 'Arriba',
	'bottomOperator': 'Abajo',
	'topBottomFact': '%{operator} %{value}%{percent} por %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Suprimir recuento superior o inferior',
	'deleteTopBottomPercent': 'Suprimir % superior o inferior',
	'topBottomTitle': 'Este objeto solamente',
	'deleteTopBottom': 'Suprimir recuento superior o inferior',
	'editTopBottom': 'Editar recuento superior o inferior',
	'editTopBottomCount': 'Editar recuento superior o inferior',
	'editTopBottomPercent': 'Editar % superior o inferior',
	'ariaDeleteTopBottomCountLabel': 'Pulse la tecla DELETE (suprimir) para suprimir el recuento superior o inferior.',
	'ariaDeleteTopBottomPercentLabel': 'Pulse la tecla Supr para suprimir el % superior o inferior.',
	'ariaEditTopBottomCountLabel': 'Pulse la tecla Intro para editar el recuento superior o inferior.',
	'ariaEditTopBottomPercentLabel': 'Pulse Intro para editar el % superior o inferior.',
	'ariaDeleteDrillStateLabel': 'Pulse la tecla Intro para editar el recuento superior o inferior.',
	'drillUpStateTitle': 'Detallar menos',
	'drillDownStateTitle': 'Detallar más',
	'ariaEditTopBottomLabel': 'Pulse la tecla Intro para editar el recuento superior o inferior.',
	'ariaDeleteTopBottomLabel': 'Pulse la tecla DELETE (suprimir) para suprimir el recuento superior o inferior.',
	'allKeyDriversLabel': 'Automático (todos los controladores)',
	'filter_drag_and_drop_single_dock': 'Arrastre y suelte los datos aquí para filtrar.',
	'filter_drag_and_drop_all_tabs': 'Arrastre y suelte los datos aquí para filtrar todas las pestañas.',
	'filter_drag_and_drop_current_tab': 'Arrastre y suelte los datos aquí para filtrar esta pestaña.',
	'filter_empty_consume_mode': 'No se ha aplicado ningún filtro.',
	'filterClearAllItems': 'Borrar todos los filtros',
	'filterDeleteAllItems': 'Suprimir todos los filtros',
	'filterDockChevronLeft': 'Desplácese por los datos',
	'filterDockChevronRight': 'Desplácese por los datos',
	'filterIconLabel_Single': 'Filtros',
	'filterIconLabel_Global': 'Todas las pestañas',
	'filterIconLabel_Tab': 'Esta pestaña',
	'filterIconTooltip_Single': 'Filtros',
	'filterIconTooltip_Global': 'Filtros para todas las pestañas',
	'filterIconTooltip_Tab': 'Filtros para esta pestaña',
	'filterDropZoneTooltip_Single': 'Filtrar zona de colocación',
	'filterDropZoneTooltip_Global': 'Filtrar zona de colocación para todas las pestañas',
	'filterDropZoneTooltip_Tab': 'Filtrar zona de colocación para esta pestaña',
	'filterOverflowMenu': 'Más',
	'expand': 'Expandir',
	'collapse': 'Contraer',
	'filterDockItemNameAriaLabel': 'Pulse Intro para abrir el diálogo de filtro y definir el filtro.',
	'filterItemCanvasMove': 'Añadir al lienzo',
	'filterItemDelete': 'Suprimir filtro',
	'filterInvertRange': 'todo excepto: %{from}-%{to}',
	'filterRange': '%{from} - %{to}',
	'filter_date_after_except': 'No después de %{from}',
	'filter_date_after': 'Después de %{from}',
	'filter_date_before_except': 'No antes de %{to}',
	'filter_date_before': 'Antes de %{to}',
	'filter_date_between_except': 'No entre %{from}-%{to}',
	'filter_date_between': 'Entre %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Todos',
	'filterExcept': 'excepto %{values}',
	'filterDockToolbarButtonLabel': 'Acoplador de filtro',
	'navigateTitle': 'Navegar a',
	'current_nav_group': 'El grupo de navegación actual es %{navigation_group_name}',
	'next': 'Siguiente',
	'previous': 'Anterior',
	'multiselectMsg': '%{count} seleccionado(s)',
	'errMsgFilterItemMissingTitle': 'No se pueden cargar los valores de filtros %{itemName} debido a que estos valores no están disponibles con este conjunto de datos',
	'errMsgFilterItemGenericTitle': 'Los valores de filtro no pueden cargarse',
	'textFilterItemsNotFound': 'No hay ningún elemento disponible.',
	'nullValueLabel': '(vacío)',
	'filterConditionLabel': 'Filtrar condición',
	'filter_includesAll': 'Incluye todo',
	'filter_allMembersOfSet': 'Todos los miembros del conjunto',
	'modelFilter': 'Filtro',
	'filtersTitle': 'Propiedades del filtro',
	'search': 'Buscar',
	'clearTextFilterValue': 'Borrar',
	'invertFilterSelection': 'Invertir',
	'modellingLoading': 'Cargando...',
	'searchAll': 'Buscar todas las columnas',
	'toolbarActionPossibleKeyDrivers': 'Editar ámbito',
	'toolbarActionPossibleKeyDriversSubTitle': 'Arrastre los elementos de la izquierda para que se tengan en cuenta en el gráfico de análisis de controladores',
	'toolbarActionSort': 'Ordenar',
	'toolbarActionSortAscending': 'Orden ascendente',
	'toolbarActionSortDescending': 'Orden descendente',
	'toolbarActionSortAuto': 'Automático (%{sortOrder})',
	'toolbarActionSortCustom': 'Personalizada',
	'toolbarActionFormat': 'Formato',
	'toolbarActionFormatAbbreviation': 'Abreviar',
	'toolbarActionFormatNone': 'Automático',
	'toolbarActionFilter': 'Filtro',
	'toolbarActionTopBottom': 'Parte superior o inferior',
	'toolbarActionRmvShape': 'Eliminar forma',
	'toolbarActionToggleShapeDrop': 'Forma infográfica',
	'toolbarActionToggleShapeDropTitle': 'Crear un infográfico',
	'toolbarActionToggleShapeDropText': 'Arrastre una forma a este campo para crear un infográfico.',
	'toolbarActionAggregationType': 'Resumir',
	'toolbarDeleteActionText': 'Eliminar columna',
	'toolbarTextActionText': 'Formatear texto',
	'toolbarActionFilterLocalKeepSelected': 'Mantener',
	'toolbarActionFilterLocalExcludeSelected': 'Excluir',
	'toolbarActionFilterAllKeepSelected': 'Filtro',
	'toolbarActionSimpleCalculation': 'Cálculo simple',
	'toolbarActionDrillBack': 'Retroceder',
	'toolbarActionDrillUp': 'Detallar menos',
	'toolbarActionDrillDown': 'Detallar más',
	'toolbarActionNavigate': 'Navegar',
	'toolbarActionCreateFilterGroup': 'Crear nueva conexión',
	'toolbarActionDisconnectFilterGroup': 'Romper todos los enlaces',
	'toolbarActionLinkFilterGroup': 'Añadir a una conexión existente',
	'toolbarActionLassoSelect': 'Seleccionar herramienta',
	'toolbarActionRefreshDeveloperWidget': 'Renovar',
	'textFontFamilySubClassHairline': 'Hairline',
	'textFontFamilySubClassThin': 'Thin',
	'textFontFamilySubClassThinItalic': 'Thin Italic',
	'textFontFamilySubClassExtraLight': 'Extra Light',
	'textFontFamilySubClassExtraLightItalic': 'Extra Light Italic',
	'textFontFamilySubClassLight': 'Claro',
	'textFontFamilySubClassLightItalic': 'Light Italic',
	'textFontFamilySubClassRegular': 'Regular',
	'textFontFamilySubClassRegularItalic': 'Regular Italic',
	'textFontFamilySubClassItalic': 'Cursiva',
	'textFontFamilySubClassMedium': 'Medio',
	'textFontFamilySubClassMediumItalic': 'Medium Italic',
	'textFontFamilySubClassHeavy': 'Heavy',
	'textFontFamilySubClassHeavyItalic': 'Heavy Italic',
	'textFontFamilySubClassDemiBold': 'Demi Bold',
	'textFontFamilySubClassDemiBoldItalic': 'Demi Bold Italic',
	'textFontFamilySubClassBold': 'Negrita',
	'textFontFamilySubClassBoldItalic': 'Bold Italic',
	'textFontFamilySubClassExtraBold': 'Extra Bold',
	'textFontFamilySubClassExtraBoldItalic': 'Extra Bold Italic',
	'textFontFamilySubClassBlack': 'Negro',
	'textFontFamilySubClassBlackItalic': 'Black Italic',
	'textFontFamilySubClassStencil': 'Stencil',
	'dlg_ascending': 'ascendente',
	'dlg_descending': 'descendente',
	'dlg_custom': 'personalizado',
	'dlg_none': 'ninguno',
	'dlg_hierarchy': 'jerarquía',
	'dlg_namedSet': 'conjunto con nombre',
	'dlg_rank': 'rank',
	'remove_slider_handle': 'Eliminar descriptor de contexto',
	'visualizationLabel': 'Visualización',
	'chartLabel': 'Gráfico %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Pulse F12 para navegar por el widget',
	'f10KeyDescription': 'Pulse F10 para lanzar la vista de enfoque de widget',
	'playButtonLabel': 'Reproducir',
	'dataPlayerValueListLabel': 'Valores del reproductor de datos',
	'localFilterTitle': 'Este objeto solamente',
	'globalFilterTitle': 'Todos los objetos',
	'deleteFilter': 'Suprimir filtro',
	'editFilter': 'Editar filtro',
	'ariaEditFilterLabel': 'Pulse la tecla INTRO para editar el filtro.',
	'ariaDeleteFilterLabel': 'Pulse la tecla SUPR para suprimir el filtro.',
	'measureFilterBetween': 'Entre %{lowerBound} y %{upperBound}',
	'measureFilterNotBetween': 'No entre %{lowerBound} y %{upperBound}',
	'dimFilterIn': 'Incluye: %{in}',
	'dimFilterNotIn': 'Excluye: %{out}',
	'gtFilter': 'Después de %{lowerBound}',
	'ltFilter': 'Antes de %{upperBound}',
	'ariaEditPrompt': 'Pulse la tecla INTRO para cambiar el valor de solicitud',
	'dataPointFilterTitle': 'Puntos de datos',
	'dataPointFilterIncludeSummary': 'Se han incluido %{valueCount} puntos de datos',
	'dataPointFilterExcludeSummary': 'Se han excluido %{valueCount} puntos de datos',
	'widgetFiltersLabel': 'Filtros de widget',
	'coachMarkTitleSpiralTarget': 'Editar ámbito',
	'coachMarkContentSpiralTarget': 'Aquí puede acceder y modificar la selección de controlador de su destino.',
	'srILVTreeLabel': 'Lista',
	'geomapUnrecognizedLocations': 'Ubicaciones no reconocidas:',
	'geomapAmbiguousLocations': 'Regiones ambiguas:',
	'visualizationNotifications': 'Notificaciones de visualización:',
	'dataNotifications': 'Notificaciones de datos:',
	'autobinSuggestion': 'Activar agrupación automática',
	'LIVE_empty_visualization_hint_title': 'Crear su visualización',
	'LIVE_empty_visualization_hint_description': 'Arrastre datos aquí o a los campos.',
	'LIVE_slots_required_field_description': '%{asterisk} Indica un campo necesario',
	'LIVE_slots_drag_and_drop_description': 'Arrastre y suelte los datos en los campos para crear y filtrar la visualización.',
	'dwErrorLoadingAvailableVisualizations': 'No se pueden cargar las definiciones de visualizaciones disponibles',
	'moreDataIndicator': 'Sus datos se han recortado en %{threshold} elementos. Aplique el filtro para mostrar menos.',
	'nonCtxTopBottomInvalid': 'Definir una regla superior o inferior sin un contexto no está soportado para tablas cruzadas. Se ha eliminado de esta vista de tabla cruzada.  Vuelva a definir la regla en una o varias categorías en el contexto de %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'No se puede cargar el objeto, debido a que falta una definición de visualización.',
	'dwErrorLoadingVisualizationListNotFound': 'No se puede cargar la visualización.',
	'dwErrorRunningQuery': 'No se pueden recuperar los datos del conjunto de datos %{datasetName}.',
	'dwErrorGeoData': 'Han surgido problemas al mostrar los datos geográficos en un mapa. Elija otro tipo de visualización.',
	'dwPromptSignonCancelWarning': 'Los datos para esta visualización no están disponibles. Proporcione los credenciales correctos.',
	'dwErrorMissingDataset': 'No se puede cargar la visualización porque el conjunto de datos asociado \'%{datasetName}\' no está disponible.',
	'dwErrorRenderingVisualization': 'No se puede cargar esta visualización.',
	'dwErrorVisualizationTooSmall': 'La visualización es demasiado pequeña para mostrar los datos que contiene. Aumente el tamaño de la visualización o limite los datos que contiene.',
	'errorSourceNotFound': 'No se puede cargar la visualización, porque su origen asociado \'%{sourceName}\' no está disponible.',
	'errorActionNotSupported': 'Esta acción no está soportada por el origen de datos \'%{sourceName}\'.',
	'errorMeasureNotSupportedOnMultiEdges': 'La visualización tiene medidas en varios bordes, lo cual ya no está soportado. Coloque las medidas en un único borde.',
	'errorExceedAllowableValue': 'El número estimado de celdas supera el valor permitido de 100000. Aplique un filtro a los conjuntos proyectados para reducir el número de celdas. ',
	'propScaleLabel': 'Cantidad de iconos',
	'propScaleDescription': 'Seleccione la cantidad de iconos',
	'propScaleFew': 'Baja',
	'propScaleDefault': 'Valor predeterminado',
	'propScaleMany': 'Alta',
	'lastRefresh': 'Última renovación: Hac %{timeInterval}',
	'widgetTimer': 'Temporizador del widget',
	'datasetItemsUnavailable': 'Algunos elementos del conjunto de datos utilizados en esta visualización no están disponibles.',
	'datasetItemUnavailable': 'Este elemento del conjunto de datos no está disponible.',
	'retry': 'Reintentar',
	'widgetConditionalFormatLabel': 'Conmutar controles de formato condicional',
	'widgetConditionalFormatTitle': 'Editar color de formato condicional',
	'conditionalPalettePickerLabel': 'Distribución de valores de %{title}',
	'HistogramYAxisTitle': 'Recuento',
	'crosstabName': 'Tabla de referencias cruzadas',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'N/D',
	'summaryLabel': '%{label} con el valor %{value}',
	'infographicLabel': '%{label} con el valor %{value}',
	'warning': 'Aviso',
	'swapRowsAndColumns': 'Intercambiar filas y columnas',
	'hideSummariesLabel': 'Ocultar resúmenes',
	'showSummariesLabel': 'Mostrar resúmenes',
	'hideRowColumn': 'Ocultar',
	'showAllRowColumn': 'Mostrar todo',
	'dataAssetPropertiesLabel': 'Propiedades de visualización',
	'evAdd': 'Añadir una columna',
	'evCollapse': 'Contraer',
	'evColumns': 'Columnas',
	'evLocalFilters': 'Filtros locales',
	'evExpand': 'Expandir',
	'evFilterTooltip': 'Filtro',
	'missingColumn': 'Falta: %{columnLabel}',
	'missingFiltering': 'Faltan filtros en columnas:',
	'missingDataItem': 'No se encuentra el elemento de datos \'%{dataItemId}\' al que se hace referencia en el widget.',
	'heatByLabel': 'Uso crítico por',
	'toolbarChangeVisualization': 'Cambiar visualización',
	'modellingRelatedTablesNoneFound': 'No se han encontrado tablas relacionadas',
	'processing': 'Procesando...',
	'errorCellWarning': 'No se han podido calcular algunos valores de resumen.',
	'aggregateTypeToggler': 'Mostrar tipo de agregación ',
	'maxColumnsExceeded': 'Se ha superado el número de columnas. Se han descartado %{columns}.',
	'unboundColumns': 'No se pueden utilizar las columnas siguientes: %{columns}.',
	'unboundColumn': 'No se puede utilizar la columna siguiente: %{columns}.',
	'recommendRequestFailed': 'Ha fallado la solicitud de recomendación. Póngase en contacto con el administrador.',
	'visualizationDoesNotSupportOLAP': 'No se puede crear esta visualización basada en un origen de datos OLAP. Utilice otro origen de datos soportado.',
	'showDataBehindVizLabel': 'Mostrar datos',
	'showDataBehindVizNotSupportedLabel': 'No está soportado mostrar datos para este tipo de visualización.',
	'exploreData': 'Explorar...',
	'newExplore': 'Nueva exploración',
	'thumbnails_error_fetching': 'Error al capturar miniaturas',
	'loadedThumbnailImage': 'Se ha cargado la imagen en miniatura de tipo de visualización %{visType}',
	'autobinAxisLabel': 'grupos',
	'recommended_visualizations': 'Visualizaciones recomendadas',
	'all_visualizations': 'Todas las visualizaciones',
	'edit': 'Editar',
	'selectTargetDialogTitle': 'Seleccionar un destino de acceso a detalles',
	'noTargetInCM': 'No se puede encontrar el destino de acceso a detalles',
	'errorDrillDefinition': 'Se ha producido un error al añadir o editar la definición de obtención de detalles.',
	'errorDrillToTarget': 'Se ha producido un error al obtener detalles de \'%{targetName}\'',
	'drillThroughMappingViewLabel': 'Asignar columnas del panel de control a las solicitudes del informe de destino',
	'drillthroughScopeRadioLabel': 'Aplicar esta definición a:',
	'drillthroughScopeRadioOptionVisualization': 'Solo esta visualización',
	'drillthroughScopeRadioOptionConnection': 'Visualizaciones de la misma conexión que utilizan el miso origen de datos',
	'drillthroughScopeRadioOptionDashboard': 'Cualquier visualización en %{perspective} que utiliza el mismo origen de datos',
	'drillThroughParametersColumnTitle': 'Solicitudes \'%{targetName}\':',
	'drillThroughMetadataColumnTitle': 'Columnas de datos \'%{boardName}\':',
	'drillThroughDefinitionNoParameter': 'El destino de acceso a detalles no tiene solicitudes.',
	'drillThroughDefinitionErrorQueryingReport': 'Corrija el problema con el informe de destino e intente de nuevo crear la definición de obtención de detalles.',
	'drillThroughDefinitionErrorDlgTitle': 'Se ha producido una anomalía',
	'dlg_back': 'Retroceder',
	'dlg_close': 'Cerrar',
	'dlg_ok': 'Aceptar',
	'dlg_cancel': 'Cancelar',
	'dlg_apply': 'Aplicar',
	'drillthrough_unsaveMsg': 'Continuar sin guardar \'%{name}\'?',
	'drillthrough_jumpTo': 'Detallar más definición: %{name}',
	'drillthrough_jumpToLabel': 'Acceso a detalles',
	'drillthrough_manage': 'Gestionar...',
	'drillthrough_addNewTarget': 'Añadir una nueva definición de acceso a detalles',
	'drillthrough_manageJumpPaths': 'Gestionar definiciones de acceso a detalles',
	'drillthrough_manageJumpPaths_edit': 'Editar \'%{name}\'',
	'drillthrough_manageJumpPaths_delete': 'Suprimir \'%{name}\'',
	'drillthrough_manageAddAnotherTarget': 'Añadir otra definición de acceso a detalles',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Confirmar supresión',
	'drillthrough_manageConfirmeDeleteDrillTarget': '¿Está seguro de que desea suprimir el acceso a detalles \'%{name}\'?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Nombre de acceso a detalles duplicado',
	'drillthrough_definitionMessage': 'El acceso a detalles \'%{name}\' ya existe. Proporcione un nombre diferente',
	'drillthrough_jumpToTarget_notFound': 'No se ha encontrado el destino para el acceso a detalles \'%{name}\'',
	'drillThroughDefinitionNoParameterSubTitle': 'No se pasará ningún contexto al informe de destino.',
	'drillthrough_titleLabel': 'Título',
	'drillthrough_subTitle': 'El contexto de la visualización en su origen se utiliza para filtrar el destino %{perspective}.',
	'noPrompt': 'Sin solicitudes',
	'formatAutoDescription': 'Automático especifica el formato heredado desde el origen de datos o la visualización.',
	'formatDefaultDescription': 'Predeterminado especificado el formato heredado desde el sistema',
	'createCustomGroupAction': 'Crear grupo de datos',
	'removeCustomGroupAction': 'Eliminar grupo de datos',
	'editCustomGroupAction': 'Editar grupo de datos',
	'renameCustomGroupAction': 'Renombrar grupo de datos',
	'createCustomGroupErrorToast': 'No se ha podido crear su grupo de datos.',
	'removeCustomGroupErrorToast': 'No se ha podido eliminar su grupo de datos.',
	'editCustomGroupErrorToast': 'No se ha podido editar su grupo de datos.',
	'renameCustomGroupErrorToast': 'No se ha podido renombrar su grupo de datos.',
	'customGroupLabel': 'Grupo de datos',
	'ungroupCustomGroupLabel': 'Desagrupar',
	'renameCustomGroupLabel': 'Cambiar nombre',
	'createCustomGroupLabel': 'Crear',
	'customGroupingLabel': '%{columnLabel} (Grupo)',
	'createCustomSort': 'Crear orden personalizado',
	'createCustomSortTitle': '%{createCustomSort}: %{name}',
	'createCustomSortDesc': 'Seleccione los elementos disponibles y, a continuación cambie el orden para crear un orden personalizado.',
	'availableItems': 'Elementos disponibles',
	'selectAll': '(Seleccionar todo)',
	'customSortOrder': 'Orden de clasificación personalizado',
	'selectAvailableItemsDesc': 'Seleccione los elementos disponibles y, a continuación cambie el orden de los mismos aquí.',
	'moveToTop': 'Mover al principio',
	'clear': 'Borrar',
	'sortRemainingItemsBy': 'Ordenar elementos restantes por',
	'clearAll': 'Borrar todo',
	'resetTooltip': 'Se eliminarán todos los elementos de la lista %{customSortOrder}. Y el desplegable %{sortRemainingItemsBy} volverá al valor predeterminado.',
	'manyItemsWarning': 'Si se seleccionan muchos elementos el rendimiento del panel de control puede resultar afectado.',
	'manyItemsSelected': 'Se han seleccionado más de %{maxItems} elemento, esto puede afectar el rendimiento del panel de control.',
	'somethingWentWrong': 'Se ha producido una anomalía',
	'unableToLoadItems': 'No se han podido cargar los elementos disponibles.',
	'tryAgain': 'Vuelva a intentarlo',
	'customSortLabel': 'Orden personalizado',
	'applyError': 'No se ha podido aplicar %{action}.',
	'searchReturnedNoResults': 'Su búsqueda no ha devuelto resultados',
	'tryDifferentSearchTerm': 'Vuelva a intentarlo con un término de búsqueda distinto',
	'extVisSystem': 'Sistema',
	'extVisCustom': 'Personalizada',
	'customVisTestVisualization': 'Prueba de visualización',
	'extVisCustomVisPreview': 'vista previa',
	'extVisCustomPreviewWidgets': 'Widgets de desarrollador',
	'extVisCustomVVisualization': 'Visualización',
	'extVisCustomVisuals': 'Visualizaciones personalizadas',
	'noPermissionToManage': 'No tiene permiso para gestionar visualizaciones personalizadas.',
	'extVisCustomUpdate': 'Actualizar',
	'extVisCustomDelete': 'Suprimir',
	'extVisNoCustomVisuals': 'No hay visualizaciones personalizadas',
	'extVisNoCustomVisualsMsg': 'Actualmente no hay visualizaciones personalizadas en su organización.',
	'extVisAddCustomVisual': 'Añadir una visualización personalizada',
	'extVisNoCustomVisualsAdminMsg': 'Actualmente no hay visualizaciones personalizadas. Añada una para empezar',
	'extVisNoSDKConnection': 'No se ha creado ninguna conexión con su archivo local',
	'extVisNoSDKPreviewMsg': 'Para obtener una vista previa de sus visualizaciones, establezca una conexión.',
	'extVisMore': 'Más',
	'extVisDeleteDialogTitle': 'Suprimir visualización personalizada',
	'extVisDeleteDialogBody': '¿Está seguro de que desea suprimir visualización personalizada? Es posible que otros paneles de control e informes la estén utilizando.',
	'extVisDeleteConfirmation': 'Se ha suprimido su visualización personalizada.',
	'extVisDeleteError': 'No se ha podido suprimir su visualización personalizada. %{msg}',
	'extVisCloseToast': 'Cerrar ahora',
	'extVisAdd': 'Su visualización personalizada se ha añadido correctamente.',
	'extVisAddError': 'No se ha podido añadir su visualización personalizada. %{msg}',
	'extVisUpdate': 'Su visualización personalizada se ha actualizado correctamente.',
	'extVisUpdateError': 'No se ha podido actualizar su visualización personalizada. %{msg}',
	'extVisAddProgress': 'Importando %{name}',
	'extVisUpdateProgress': 'Actualizando %{name}',
	'extPermissionTitle': 'Acceso restringido o visualización personalizada suprimida',
	'extPermissionBody': 'No se puede ver esta visualización personalizada porque se ha suprimido o es de acceso restringido.',
	'customVizSaveWarning': 'No se han podido guardar sus visualizaciones personalizadas. No se han importado.',
	'schematicTestCaption': 'Probar Schematic',
	'schematicServiceRequestError': 'Error de servicio Schematic',
	'extVisPreviewMessage': 'Esta es una vista previa. Todavía no se ha añadido la visualización al producto.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'No definido',
	'kpiDefaultTargetLabel': 'Diana',
	'kpiNonNumericTarget': 'El valor de destino debe ser un número.',
	'kpiManualTargetSlotFilled': 'Valor aplicado al campo',
	'kpiAutoValueSize': 'Automático',
	'kpiUnableDrawSparklineLabel': 'No se ha podido trazar la Sparkline',
	'kpiUnableDrawSparklineInfo': 'Una sparkline requiere un mínimo de dos puntos en el tiempo. Cambie los datos o ajuste los filtros para ver la sparkline.',
	'conditionalFormattingEnabled': 'Color condicional',
	'currentConditionalPalette': 'Paleta condicional actual',
	'sectionName_range': 'Establecer rango',
	'rangeScaleLabel': 'Escala',
	'rangeScalePercentage': 'Porcentaje',
	'rangeScaleNumeric': 'Numérico',
	'numberOfSteps': 'Número de rangos',
	'conditionalFormattingSelectedStep': 'Rango seleccionado',
	'conditionalFormattingStartValue': 'Valor inicial',
	'conditionalFormattingEndValue': 'Valor final',
	'conditionalFormattingTextColor': 'Color del texto',
	'conditionalFormattingMin': 'Mín.',
	'conditionalFormattingMax': 'Máx.',
	'conditionalFormattingNonNumericValue': 'El valor debe ser un número.',
	'conditionalFormattingStepIndexInvalid': 'El índice del rango no es válido.',
	'conditionalFormattingValueOutOfBoundsInvalid': 'El valor debe estar en el rango %{start} - %{end}.',
	'conditionalFormattingValueShouldBeLower': 'El valor debe ser menor o igual que %{value}.',
	'conditionalFormattingValueSouldBeHigher': 'El valor debe ser mayor o igual que %{value}.',
	'conditionalFormattingDeleteStep': 'Elimine el rango seleccionado',
	'conditionalFormattingRestoreSteps': 'Restaurar rangos',
	'conditionalFormattingReversePalette': 'Invertir colores',
	'conditionalFormattingShapeIndicator': 'Forma de indicador',
	'conditionalFormattingIconNone': 'Sin forma',
	'conditionalFormattingIconArrowUp': 'Flecha arriba',
	'conditionalFormattingIconArrowRight': 'Flecha derecha',
	'conditionalFormattingIconArrowDown': 'Flecha abajo',
	'conditionalFormattingIconCaretUp': 'Signo de intercalación arriba',
	'conditionalFormattingIconDash': 'Guión',
	'conditionalFormattingIconCaretDown': 'Signo de intercalación abajo',
	'conditionalFormattingIconCheckmark': 'Marca de selección',
	'conditionalFormattingIconWarning': 'Aviso',
	'conditionalFormattingIconXSymbol': 'Símbolo X',
	'conditionalFormattingIconCircle': 'Círculo',
	'conditionalFormattingIconTriangle': 'Triángulo',
	'conditionalFormattingIconDiamond': 'Rombo',
	'conditionalFormattingIconFaceSatisfied': 'Cara de satisfacción',
	'conditionalFormattingIconFaceNeutral': 'Cara neutral',
	'conditionalFormattingIconFaceDissatisfied': 'Cara de no satisfecho',
	'suppression': 'Supresión',
	'suppressNone': 'Ninguno',
	'suppressRowsAndColumns': 'Filas y columnas',
	'suppressRows': 'Filas',
	'suppressColumns': 'Columnas',
	'enableSuppression': 'Habilitar supresión',
	'disableSuppression': 'Inhabilitar supresión',
	'loadVisDefinitionError': 'No se puede cargar la definición de la visualización %{id}',
	'emptyVisualization': 'Visualización vacía',
	'expandCollapse': 'Expandir y contraer',
	'expandBtnLabel': 'Expandir',
	'collapseBtnLabel': 'Contraer',
	'prop_sizeInputNonNumericValue': 'El valor debe ser un número.',
	'prop_sizeValueShouldBeHigher': 'El valor debe ser mayor que %{value}.',
	'fontPropLabel': 'Familia de fuentes',
	'fontSizePropLabel': 'Tamaño de fuente',
	'sectionItemAxisTitle': 'Título de eje del elemento',
	'sectionItemAxisLabel': 'Etiqueta de eje de elemento',
	'sectionValueAxisTitle': 'Título de eje del valor',
	'sectionValueAxisLabel': 'Etiqueta de eje del valor',
	'fontFamily': 'family',
	'fontSize': 'size',
	'visExportFileName': 'Visualización',
	'ds-missingDataSet': 'No se ha podido encontrar el conjunto Asegúrese de que el conjunto de datos se ha creado correctamente.',
	'ds-missingDashboardId': 'Guarde el panel de control antes de crear el conjunto de datos.',
	'ds-unsupportedDataSourceType': 'El tipo de origen de datos %{type} no está soportado.'
});
